import {useEffect, useState} from "react";
import axios from 'axios';
import {setError} from "../../../slices/error/ErrorSlice";
import {useDispatch} from "react-redux";

export default function CodeGroup() {
    const dispatch = useDispatch();

    const[list, setList] = useState([]);

    useEffect(() => {
        getList();
    }, []);

    function getList() {
        axios.get('/api/code-group-list')
            .then(res => {
                setList(res.data);
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    let rows = list.map(item =>
        <tr key={item.id}>
            <td>{item.code}</td>
            <td>{item.name}</td>
        </tr>
    )

    return (
        <>
            <h1>Коды и группы</h1>

            <table className="table table-striped table-bordered">
                <thead>
                <tr>
                    <th scope="col" style={{width: 95}}>Код</th>
                    <th scope="col">Наименование</th>
                </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        </>
    )
}